
const parentItems = document.querySelectorAll('.menu > li');

// parentItems.forEach(parentItem => {
//   const childMenu = parentItem.querySelector('.submenu');
//   if (childMenu) {
//     parentItem.addEventListener('mouseenter', () => {
//       childMenu.style.display = 'block';
//     });
//     parentItem.addEventListener('mouseleave', () => {
//       childMenu.style.display = 'none';
//     });
//   }
// });

let link = document.querySelectorAll(".section-quiks__link--texts");
let details = document.querySelectorAll(".about-product-details");
let Quicks = document.querySelectorAll(".Quicks-link__text");

link.forEach((ele,i)=>{
    ele.addEventListener("click",(e)=>{
      let id=ele.getAttribute('data-id')
      console.log(i,id)
       for (let index = 0; index < link.length; index++) {
        if(index==id) {
        link[index].classList.add('active')
      }
      else
      {
       link[index].classList.remove('active')
      }
      }
    })
   })


   link.forEach((ele) => {
    ele.addEventListener("click", (e) => {
      for (let index = 0; index < details.length; index++) {
        if (ele.getAttribute("data-id") == details[index].getAttribute("data-id")) {
          details[index].setAttribute("open", true);
        } else {
          details[index].removeAttribute("open");
          link[index].classList.remove('active')
        }
        if(details[index].hasAttribute("open")){
          link[index].classList.add('active')
        }
        else{
          link[index].classList.remove('active')
        }
      }
    });
  });

Quicks.forEach((ele) => {
  ele.addEventListener("click", (e) => {
    for (let index = 0; index < details.length; index++) {
      if (ele.getAttribute("data-id") == details[index].getAttribute("data-id")) {
        details[index].setAttribute("open", true);
      } else {
        details[index].removeAttribute("open");
      }
    }
  });
});
